<template>
    <div class="user_auth" :class="locale==='en'?'user_auth_en':''">
        <div class="user_auth_container">
            <div class="title">{{$t('personalCenter.developerCertification')}}</div>
            <div class="user_step">
                <el-steps align-center :active="active" finish-status="success"> 
                    <el-step :class="{ 'stepone': active == 1 }" :title="$t('personalCenter.submitCertificationInfo')" />
                    <el-step :title="$t('personalCenter.pendingReview')" />
                    <el-step :title="$t('personalCenter.certifiedSuccess')" />
                </el-steps>
            </div>
            <div class="form_container">
                <el-form :disabled="disabled" ref="form" :model="userForm" :rules="rules" :label-width="locale === 'en' ? '182px':'116px'">
                    <el-form-item :label="$t('personalCenter.yourName')" prop="fullName">
                        <el-input :placeholder="$t('personalCenter.pleaseEnterRelName')" v-model="userForm.fullName" @blur="onFullNameBlur('fullName')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('personalCenter.companyName')" prop="enterpriseName">
                        <el-input :placeholder="$t('personalCenter.pleaseEnterRelCompanyName')" v-model="userForm.enterpriseName" @blur="onFullNameBlur('enterpriseName')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('personalCenter.contactInfo')" prop="contactMobile">
                        <el-input :placeholder="$t('personalCenter.writeTelOrEmail')" v-model.trim="userForm.contactMobile"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('personalCenter.snCode')" prop="sn">
                        <el-input :placeholder="$t('personalCenter.writeSnCode')" v-model.trim="userForm.sn"></el-input>
                    </el-form-item>
                    
                </el-form>
            </div>
            
            <div class="submit-btn">
                <el-button :disabled="disabled" style="transform: translateX(-12px);" @click="submitForm" color="#386AEA">{{$t('personalCenter.submit')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { normalizeValue, validateMobileOrEmail, validateEmail, validateUserName,validateEnterName,validateSNCode } from '@/utils/common.js'
import { authenticationApi } from '@/api/control'
import { throttle } from '@/utils/common'
import { ElMessage } from 'element-plus'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

const router = useRouter()
const disabled = ref(false)
const active = ref(1)//步骤条
//表单dom
const form = ref(null)
const nameError = ref('')

const userForm = ref({
    fullName: '',
    enterpriseName: '',
    contactMobile: '',
    sn: '',
})

//表单校验规则
const rules = ref({
    fullName: [
        { required: true, message: t("personalCenter.pleaseEnterYourName"), trigger: 'blur' }, 
        { validator: validateUserName, trigger: 'blur' }
    ],
    enterpriseName: [
        { required: true, message: t("personalCenter.pleaseEnterCompanyName"), trigger: 'blur' },
        { validator: validateEnterName, trigger: 'blur' }
    ],
    contactMobile: [
        { required: true, message: t("personalCenter.writeContactInfo"), trigger: 'blur' },
        { validator: locale.value === 'en'? validateEmail:validateMobileOrEmail, trigger: 'blur' }
    ],
    sn: [
        { required: true, message: t("personalCenter.writeSnCode"), trigger: 'blur' },
        { validator: validateSNCode, trigger: 'blur' }
    ],
})

const onFullNameBlur = (val) =>{
    userForm.value[val] = normalizeValue(userForm.value[val])
}

//提交表单
const submitForm = throttle(() => {
    // 发送认证请求
    form.value.validate((value) => {
        console.log(value);
        if (value ) {
            authenticationApi({
                        ...userForm.value,
                        // authenticationType: '0',
                    }).then(res => {
                        console.log(res);
                        if (res.code === 200) {
                            active.value = 2
                            // disabled.value = true
                            router.push('/home/controlsyshome')
                            ElMessage({
                                message: res.message,
                                customClass: "custom-message1",
                            });
                        }
                    }).catch(err => { console.log(err); })
        } 
    })
}, 1000)
</script>

<style lang="scss" scoped>
@media (max-width: 1200px) {
    .user_auth_container {
        width: calc(100vw - 80px);
        .img_container{
            flex-wrap: wrap;
            .img_mid{
                margin: 16px 0px;
            }
        }
    }
}

@media (min-width: 1200px) {
    .user_auth_container {
        width: 1105px;
        .form_container{
            padding-left: 137px;
            .img_mid{
                margin: 0px 16px;
            }
        }
    }
}

.user_auth {
    background-color: #f8f8f8;
    padding: 24px 0px 40px;
    min-height: 100vh;

    .user_auth_container {
        min-height: 1040px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;
        padding-top: 32px;
        padding-left: 24px;
        position: relative;

        .el-button {
            width: 176px;
            height: 64px;
            font-weight: 500;
            font-size: 16px;
        }

        .notice_tip {
            display: flex;
            margin-left: 165px;
            color: #333;
            margin-top: 40px;

            div p {
                margin-bottom: 0px;
                line-height: 1.8;
                color: #999;
                // font-family: PingFang SC;
                font-size: 12px;
                font-weight: 500
            }
        }

        ::v-deep .el-input__inner {
            // background-color: #292929 !important;
            // -webkit-box-shadow: 0 0 0 1000px #292929 inset;
            // -webkit-text-fill-color: #fff !important;
            // color: #fff !important;
            caret-color: #386AEA;
            font-size: 16px;
            color: #333;
            // caret-color: #386AEA;
        }

        // ::v-deep .el-checkbox__inner {
        //     border: 0.5px solid #ffffff32;
        // }
        ::v-deep .el-form-item {
            width: 480px;
            margin-bottom: 16px;
            align-items: center;
        }

        ::v-deep .el-form-item.is-error {
            margin-bottom: 48px;
        }

        ::v-deep .el-form-item.is-error .el-input__wrapper {
            box-shadow: 0 0 0 0.5px #E70A27 inset !important;
        }

        ::v-deep .el-input__wrapper {
            width: 400px;
            height: 64px;
            padding: 1px 24px;
            background: rgba(0, 0, 0, 0.05);
            box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.2) inset !important;
        }

        ::v-deep .el-form-item__label {
            padding-right: 24px;
            color: #333;
            font-size: 16px;
            font-weight: 500;
        }

        ::v-deep .el-form-item__error {
            color: #E70A27;
            line-height: 24px;
            padding-top: 0px;
            margin: 8px 0px 16px;
            font-weight: 500;
        }

        .stepone {
            ::v-deep .el-step__line-inner {
                width: 50% !important;
                border-width: 1px !important;
            }
        }

        ::v-deep .el-step__title.is-wait {
            color: #333;
            font-weight: 500;
        }

        ::v-deep .el-step__line {
            background-color: rgba(0, 0, 0, 0.1);
            height: 1px;
            // top: 7px;
        }

        ::v-deep .el-step__head.is-success {
            color: #386AEA;
            border-color: #386AEA;
        }

        ::v-deep .el-step__title.is-success,
        ::v-deep .el-step__title.is-process {
            color: #333;
            font-weight: 500;
        }

        ::v-deep .el-step__icon {
            width: 12px;
            height: 12px;
            background-color: #386AEA;
            border: none;

            svg,
            .el-step__icon-inner {
                display: none;
            }
        }

        .user_step {
            // width: 772px;
            margin: 90px 55px 99px 40px;
        }

        .title {
            color: #333;
            // font-family: PingFang SC;
            font-size: 24px;
            font-weight: 500;
        }
    }
    .submit-btn {
        text-align: center;
        // margin-top: 40px;
    }
}

// 英文版样式
.user_auth_en .user_auth_container{
    ::v-deep .el-form-item {
        width: 551px!important;
    }
}
</style>
<style lang="scss">
.user_auth {
    .submit-btn {
        position: absolute;
        bottom: 80px;
        left: 0;
        right: 0;
        text-align: center;
        // margin-top: 40px;
        .el-button {
            &:focus {
                background: #386AEA;
            }
            &:hover, &:active {
                background: rgb(116, 151, 240);
                border-color: rgb(116, 151, 240);
            }
        }
    }
}


</style>